import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'

// ═══════════════════════════════════════════════════════════════════════════
// Types
// ═══════════════════════════════════════════════════════════════════════════

export interface CardHeaderActionsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

// ═══════════════════════════════════════════════════════════════════════════
// Component
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Container for action buttons in CardHeader.
 *
 * @example
 * <CardHeader>
 *   <CardHeaderTitle>ITEM 1</CardHeaderTitle>
 *   <CardHeaderActions>
 *     <EditButton onClick={handleEdit} />
 *     <DeleteButton onClick={handleDelete} />
 *   </CardHeaderActions>
 * </CardHeader>
 */
const CardHeaderActions = React.memo(
  ({ children, style, className, ...props }: CardHeaderActionsProps) => {
    const [css] = useStyletron()

    const actionsClassName = css({
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    })

    return (
      <div
        className={`${actionsClassName} ${className || ''}`}
        style={style}
        {...props}
      >
        {children}
      </div>
    )
  }
)

CardHeaderActions.displayName = 'CardHeaderActions'

export default CardHeaderActions
